module.exports = __webpack_public_path__ + "img/ms.b2e6e723.svg";